module.exports = __webpack_public_path__ + "fonts/Inter-200-latin35.8e433c0.woff2";